const fireStepChangeEvent = () => {
  console.log('fireStepChangeEvent...');
  try {
    // fire the utag link event
    if (window.onStepChangeEvent) {
      window.onStepChangeEvent();
    }
  } catch (e) {
    console.log(
      'onStepChangeEvent failed - please check the Assessment Step Change Script'
    );
  }
};

export default fireStepChangeEvent;
